// src/components/Navigation.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = ({ isOpen, onLinkClick = () => {} }) => {
  const location = useLocation();
  
  const navItems = [
    { path: '/', label: 'Home' },
    //just to test with two
    {
      label: "Integralis",
      children: [
        { path: '/association', label: 'Association and representatives' },
        { path: '/events', label: 'Events calendar' },
        { path: '/merch', label: 'Merch' }
      ]
    }, 
    {
      label: "Documents",
      children: [
        { path: '/rulesFI', label: 'Official Rules (FI)' },
        { path: '/rulesEN', label: 'Rules in English' },
        { path: '/privacy', label: 'Privacy'},
        { path: '/documents/equality_plan', label: 'Equality plan'},
        { path: '/documents/safer_space_principles', label: 'Safer space principles'},
        { path: '/documents/environmental_plan', label: 'Environmental Plan'},
        { path: '/board', label: 'Board documents' } //change later
      ]
    },   
    { path: '/partners', label: 'Partners' },
    
    { path: '/freshers', label: 'Freshers' },
    { path: '/harassment', label: 'Harassment' },
    { path: '/study', label: 'Study' },
    
  ];

  return (
    <nav
      className={`navigation ${isOpen ? 'navigation--open' : ''}`}
      aria-label="Main navigation"
    >
      <ul className="nav-list">
        {navItems.map((item) => (
          <li key={item.path || item.label} className="nav-item">
            {item.children ? (
              <details className='dropdown'>
                <summary className='nav-link'>{item.label}</summary>

                <ul className="dropdown-menu">
                  {item.children.map((child) => (
                    <li key={child.path}>
                      <Link
                        to={child.path}
                        className={`nav-link ${
                          location.pathname === child.path ? "active" : ""
                        }`}
                        onClick={onLinkClick}
                      >
                        {child.label}
                      </Link>
                    </li>
            ))}
          </ul>
        </details>) : (
           <Link
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={onLinkClick}   // closes menu on mobile
            >
              {item.label}
            </Link>
          
        )}
        </li>
        ))}
        </ul>
    </nav>
  );
};

export default Navigation;
